import { render, staticRenderFns } from "./adminindex.vue?vue&type=template&id=498683f6"
import script from "./adminindex.vue?vue&type=script&lang=js"
export * from "./adminindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports